/* Response Time CSS */

export default theme => ({
    root: {
        "& .MuiPaper-root": {
            borderColor: '#fff'
        },
    },
    refreshButton: {
        display: 'flex',
        justifyContent: 'space-between'
        //margin: -theme.spacing.unit * 2
    },
    chart: {
        width: '500px',
        margin: '0 auto',
        height: '10px',
        textAlign: 'center',
    },
    header: {
        height: '40px',
        color: theme.palette.text.secondary
    },
    stats: {
        marginTop: theme.spacing(2),
        display: 'flex',
        justifyContent: 'center'
    },
    portletFooter: {
        display: 'flex',
        justifyContent: 'space-between'
    },
    content: {
        //alignSelf: 'center',
        //alignContent: 'space-around',
        textAlign: 'center',
    },
    details: {
        textAlign: 'left',
        /*[theme.breakpoints.down('md')]: {
          textAlign: 'left',
        },
        [theme.breakpoints.up('md')]: {
          textAlign: 'center',
        },
        [theme.breakpoints.up('lg')]: {
          textAlign: 'left',
        },*/
        //flex: '1 100%',
        //marginTop: '50px',
        //marginBottom: '50px',
        //marginRight: '50px',
        //marginLeft: '50px'
    },
    button: {
        backgroundColor: 'white'
    },
    updateTime:{
        fontWeight: 500,
        /* width: '200px' */
    },
    rounded: {
      color: '#3b3b3b',
      backgroundColor: '#fff',
      height: '30px'
    }

});

